import React from 'react';

interface UnencryptedCheckboxAgreementProps {
  isVisible: boolean;
  isAcknowledgedByUser: boolean;
  onChangeIsAcknowledgedByUser: (event: React.ChangeEvent<HTMLInputElement>) => void;
}

const UnencryptedCheckboxAgreement: React.FC<UnencryptedCheckboxAgreementProps> = ({isVisible, isAcknowledgedByUser, onChangeIsAcknowledgedByUser}) => {
  return isVisible? 
    (<div className="" style={{backgroundColor: '#ffec9fff', padding: '2px 8px', borderRadius: '2px'}}>
        <input
          type="checkbox"
          checked={isAcknowledgedByUser}
          onChange={onChangeIsAcknowledgedByUser}
        />
        {' '}
        I acknowledge the risks of uploading an unencrypted file.
    </div>) : 
    <></>
}

export default UnencryptedCheckboxAgreement